import { CanDeactivateFn } from '@angular/router';
import { MobileManageProfilePageComponent } from './mobile-manage-profile-page.component';

export const mobileManageProfileUnsavedGuard: CanDeactivateFn<unknown> = (component) => {
  const page =
    component instanceof MobileManageProfilePageComponent
      ? component
      : MobileManageProfilePageComponent.activePage;

  return page?.confirmLeaveWithUnsavedChanges() ?? true;
};
